<template>
  <div class="view-container">
    <vue-portal to="hrsys-navbar-actions">
      <vx-tooltip :text="$t('buttons.create')" class="ml-2" position="bottom">
        <base-button @click="openCreationForm" class="self-end" icon="plus"></base-button>
      </vx-tooltip>
    </vue-portal>
    <div class="">
      <base-loader :loading="loadingTable">
        <div class="flex justify-center mb-5">
          <base-button @click="changeDay(-1)" button="filled" class="px-2 py-2 rounded-full self-end mb-1"
                       icon="arrow-left"></base-button>
          <div class="text-xl w-32 font-semibold mx-2 self-center">
            <date-picker v-model="selectedDate" @input="goToDate"/>
          </div>
          <base-button @click="changeDay(+1)" button="filled" class="px-2 py-2 rounded-full self-end mb-1"
                       icon="arrow-right"/>
        </div>
        <timecard-table
          :header="tableHeader"
          :timecardList="list"
          :updatingTimecards="updatingTimecards"
          @delete="promptDeleteTimecard"
          @details="openDetails"/>
        <pagination :pagination="pagination" @input="changePage" v-if="pagination.total"/>
      </base-loader>
    </div>
  </div>

</template>

<script>
  import * as moment from 'moment';
  import TimecardTable from "../../components/timecards/TimecardTable";
  import Pagination from "../../components/Pagination";
  import Timecards from "../../services/Timecards";
  import DatePicker from "../../components/DatePicker";
  import EventBus from "../../utilities/eventBus";

  export default {
    name:"Timecard",
    components:{
      TimecardTable,
      Pagination,
      DatePicker
    },
    data:() => ({
      list:[],
      pagination:{},
      queryParams:{
        include:'project.client',
        from:moment().format('YYYY-MM-DD'),
        to:moment().format('YYYY-MM-DD'),
        page:1,
      },
      selectedDate:moment().toDate(),
      updatingTimecards:[],
      loadingModalActions:false,
      loadingTable:false,
    }),
    methods:{
      changeDay(diff) {
        this.selectedDate = moment(this.selectedDate).add(diff, 'days').toDate();
        this.search();
      },
      goToDate(date) {
        this.queryParams.from = moment(date).format('YYYY-MM-DD')
        this.queryParams.to = moment(date).format('YYYY-MM-DD')
        this.search()
      },
      getTimecard() {
        this.loadingTable = true
        Timecards.list(this.queryParams).then(res => {
          this.list = res.data
        }).catch(error => {
          this.$notificationService.error(error.message)
        }).finally(() => {
          this.loadingTable = false
        })
      },
      openDetails(timecard) {
        EventBus.$emit('updateTimecard', timecard)
      },
      openCreationForm() {
        EventBus.$emit('createTimecard', this.selectedDate)
      },
      promptDeleteTimecard(timecard) {
        this.$vs.dialog({
          type:'confirm',
          color:'danger',
          title:this.$t('timecards.prompts.deleteTitle'),
          text:this.$t('timecards.prompts.deleteText'),
          accept:() => {
            this.deleteTimecard(timecard)
          }
        });
      },
      deleteTimecard(timecard) {
        Timecards.delete(timecard.id).then(() => {
          this.list.splice(this.getTimecardIndex(timecard.id), 1).join('')
          // this.getTimecard()
          this.$notificationService.success(`${this.$t('timecards.timecard')} ${this.$t('notification.successDelete')}`)
        }).catch(error => {
          this.$notificationService.error(error.message)
        }).finally(() => {
          this.updatingTimecards.splice(this.updatingTimecards.indexOf(timecard.id))
        })
      },
      search() {
        this.$router.push({query:this.queryParams}).catch(() => {
        })
        this.queryParams.page = 1
        this.getTimecard()
      },
      getUrlParams() {
        let vm = this;
        if (this.$route.query.page) {
          vm.queryParams = Object.assign({}, vm.$route.query);
        }
      },
      changePage(newPage) {
        this.queryParams.page = newPage
        this.$router.push({query:this.queryParams}).catch(() => {
        })
        this.getClients()
      },
      getTimecardIndex(id) {
        return this.list.findIndex((timecard) => timecard.id === id)
      },
      clearSelection() {
        this.loadingModalActions = false
        this.action = null
      }
    },
    computed:{
      tableHeader() {
        return ([
          this.$t('timecards.table.project'),
          this.$t('timecards.table.date'),
          this.$t('timecards.table.start_time'),
          this.$t('timecards.table.end_time'),
          this.$t('timecards.table.notes'),
          this.$t('timecards.table.actions')
        ])
      }
    },
    mounted() {
      this.getUrlParams()
      this.search()
      EventBus.$on('timecardDone', () => this.getTimecard())
    },
    watch:{
      selectedDate(val) {
        this.queryParams.from = moment(val).format("YYYY-MM-DD")
        this.queryParams.to = moment(val).format("YYYY-MM-DD")
      }
    }
  }
</script>

<style scoped>

</style>
